import { BaseProduct } from 'services/api/entities/catalog/baseProduct/types/internal/baseProduct-models'
import { EntityDescriptor } from '.'
import { BASE_PRODUCT_HEADERS, formatBaseProductCsv } from './common'

export const musics: EntityDescriptor<BaseProduct> = {
  headers: BASE_PRODUCT_HEADERS,
  format: formatBaseProductCsv,
}
